import "./styles/custom.scss";
import React, { lazy } from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import App from "./App";
import "./i18n/Language.js";
import {
  ConnectDialog,
  Connect2ICProvider,
} from "@connect2ic/react";
import { InternetIdentity } from "@connect2ic/core/providers/internet-identity";
import {PlugWallet} from '@connect2ic/core/providers/plug-wallet';
import { idlFactory } from "./team_leader.did";
import {idlFactory as icpIdlFactory} from "./ledger.public.did";
import { idlFactory as airdopIdlFactory } from "./airdrop.did";
import { idlFactory as accountIdlFactory } from "./account_capacity.did";
import { idlFactory as wdnIdlFactory } from "./wdn.did";
import "@connect2ic/core/style.css"
import {createBrowserHistory} from 'history'

const providers = [
  // Either import them from @connect2ic/core
  InternetIdentity,
  // PlugWallet,
  // or create your own (check the existing ones to see how they're implemented)
];

//线上环境
const canisterDefinitions = {
  team: {
    canisterId: "wi6h7-sqaaa-aaaak-abv7a-cai",
    idlFactory: idlFactory,
  },
  icp:{
    canisterId: "ryjl3-tyaaa-aaaaa-aaaba-cai",
    idlFactory: icpIdlFactory,
  },
  airdrop:{
    canisterId: "xydfy-3qaaa-aaaak-ab6lq-cai",
    idlFactory: airdopIdlFactory,
  }
  
};

// ///本地环境
// const canisterDefinitions = {
//   team: {
//     canisterId: "t6rzw-2iaaa-aaaaa-aaama-cai",
//     idlFactory: idlFactory,
//   },
//   icp:{
//     canisterId: "tqtu6-byaaa-aaaaa-aaana-cai",
//     idlFactory: icpIdlFactory,
//   },
//   airdrop:{
//     canisterId: "su63m-yyaaa-aaaaa-aaala-cai",
//     idlFactory: airdopIdlFactory,
//   },
//   account:{
//     canisterId:"rkp4c-7iaaa-aaaaa-aaaca-cai",
//     idlFactory:accountIdlFactory,
//   },
//   // node:{
//   //   canisterId:"rno2w-sqaaa-aaaaa-aaacq-cai",
//   //   idlFactory:airdopIdlFactory,
//   // },
//   wdn:{
//     canisterId:"st75y-vaaaa-aaaaa-aaalq-cai",
//     idlFactory:wdnIdlFactory,
//   }
  
// };


const host = "https://ic0.app";
// const host = "http://192.168.2.9:8000"

const root = ReactDOM.createRoot(document.getElementById("root"));
const Home = lazy(() => import("./components/home/Home"));
const Apply = lazy(() => import("./components/apply/Apply"));
const Airdrop = lazy(() => import("./components/airdrop/Airdrop"));
const Loading = lazy(() => import("./components/loading/loading"));
const Success = lazy(() => import("./components/loading/success"));
const Sorry = lazy(() => import("./components/loading/sorry"));
const Personal = lazy(() => import("./components/notification/personal"));
const User = lazy(() => import("./components/user/User"))
const history = createBrowserHistory();

root.render(
  <Connect2ICProvider
    canisters={canisterDefinitions}
    providers={providers}
    host={host}
    dev={true}
  >
    <Router history= {history}>

      <Routes>
           <Route path="/" element={<App />}>
          <Route path="/" element={<Home />}></Route>
          <Route path="Apply" element={<Apply />}></Route>
          <Route path="Airdrop" element={<Airdrop />}></Route>
          <Route path="User" element={<User />}></Route>
          {/* 预览 */}
          <Route path="Loading" element={<Loading />}></Route>
          <Route path="Success" element={<Success />}></Route>
          <Route path="Sorry"  element={<Sorry />}></Route>
          <Route path="Personal" element={<Personal />}></Route>
     
        </Route>
      </Routes>
    </Router>
    <ConnectDialog/>
  </Connect2ICProvider>
);

reportWebVitals();

export {providers, canisterDefinitions, host};
